import gql from "graphql-tag";

export const RUN_JOB = gql`
	mutation runJob($jobId: Int!) {
		runJob(input: { jobId: $jobId }) {
			jobRun {
				id
				start
				finish
				description
			}
		}
	}
`;
